import * as React from 'react';
import { validateEmail } from '@mc/react-format';

import { StringInput } from '../../string/StringInput';
import { FormItem } from './FormItem';
import { Field } from '../Field';

import type { FieldRenderProps } from 'react-final-form';

import type { VFFieldProps } from '../types';
import { DATA_FORM_INPUT } from '../../common/data';

export type EmailProps = VFFieldProps<React.ComponentProps<typeof StringInput>>;
export const Email = React.forwardRef<HTMLInputElement, EmailProps>(
  (
    {
      name,
      label,
      validate: baseValidation,
      className,
      inputClassName,
      contentClassName,
      inlineValidation,
      onChange: customOnChange,
      required,
      disabled,
      readOnly,
      validateWarning,
      ...other
    },
    ref
  ) => {
    const validation = React.useCallback(
      (value: any): string | Promise<any> | undefined => {
        return baseValidation ? baseValidation(value) : validateEmail(value);
      },
      [baseValidation]
    );
    return (
      <FormItem
        name={name}
        label={label}
        inlineValidation={inlineValidation}
        className={className}
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name} validate={validation}>
          {({
            input: { value, onChange, name, ...nother },
            meta,
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (e: React.ChangeEvent<HTMLInputElement>) => {
                let realVal: string | undefined = e.target.value;
                if (realVal === '') {
                  realVal = undefined;
                }
                const rv = { target: { name, value: realVal } };
                customOnChange ? customOnChange(realVal as any) : onChange?.(rv);
              },
              [customOnChange, onChange, name]
            );
            return (
              <StringInput
                {...DATA_FORM_INPUT(name)}
                className={inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                name={name}
                {...other}
                disabled={disabled || meta.submitting}
                readOnly={readOnly}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
